import { useEffect } from "react";
import { PageHeader } from "@/components/PageHeader";

// Attribution for CC-BY / third-party assets. Add a row per credited track/asset
// so a single page satisfies every attribution requirement site-wide.
const Credits = () => {
  useEffect(() => {
    document.title = "Credits — Quizrun";
  }, []);

  return (
    <main>
      <PageHeader
        eyebrow="Credits"
        title="Credits & Attributions"
        intro={
          <>Music and media used on this site under their respective licenses.</>
        }
      />

      <section className="container mx-auto px-4 md:px-8 pb-16">
        <div className="max-w-2xl space-y-6 text-sm leading-relaxed text-muted-foreground">
          <div>
            <h2 className="text-base font-semibold text-foreground mb-2">
              Music
            </h2>
            <p>
              &ldquo;Blippy Trance&rdquo; by Kevin MacLeod (
              <a
                href="https://incompetech.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-orange hover:underline"
              >
                incompetech.com
              </a>
              ) — licensed under Creative Commons: By Attribution 4.0 (
              <a
                href="https://creativecommons.org/licenses/by/4.0/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-orange hover:underline"
              >
                CC BY 4.0
              </a>
              ).
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Credits;
